import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SEOHead from '../components/seo/SEOHead';
import { trackPageView } from '../utils/analytics';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-bold text-white mb-3">{title}</h2>
    <div className="text-white/70 text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

const PrivacyPolicyPage = () => {
  useEffect(() => {
    trackPageView('PrivacyPolicy');
  }, []);

  return (
    <>
      <SEOHead
        title="Privacy Notice - XION Medical Philippines"
        description="Privacy Notice for XION Medical Philippines, distributed by Fortschritt Medical Supplies Inc. (FMSInc.), in compliance with the Data Privacy Act of 2012 (RA 10173)."
        path="/privacy-policy"
      />
      <Header />
      <main className="pt-32 min-h-screen bg-hud" data-testid="privacy-policy-page">
        <div className="max-w-3xl mx-auto px-6 py-16">
          <p className="terminal-label text-[#00FFD1] mb-4">// Data Privacy Act of 2012 (RA 10173)</p>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy Notice</h1>
          <p className="text-white/60 text-sm mb-10">
            How Fortschritt Medical Supplies Inc. (FMSInc.), the exclusive Philippine distributor of XION
            Medical, collects and processes your personal data.
          </p>

          <Section title="1. Who we are">
            <p>
              This website is operated by Fortschritt Medical Supplies Inc. (&ldquo;FMSInc.&rdquo;,
              &ldquo;we&rdquo;, &ldquo;us&rdquo;), the exclusive distributor of XION Medical products in the
              Philippines. We are the personal information controller for data submitted through this site.
            </p>
          </Section>

          <Section title="2. What we collect">
            <p>
              When you submit an inquiry, we collect the information you provide: your name, email address,
              phone number, organization, the nature and purpose of your inquiry, and your message. We do not
              knowingly collect sensitive personal information or health data through this form.
            </p>
          </Section>

          <Section title="3. Why we collect it">
            <p>
              We process your personal data for the sole, specific purpose of responding to your inquiry,
              preparing quotations, and providing related product information and customer support. We do not
              sell your data, and we do not use it for unrelated marketing without separate consent.
            </p>
          </Section>

          <Section title="4. How we store and protect it">
            <p>
              Your data is stored securely and accessed only by authorized FMSInc. personnel necessary to
              fulfil your request. We retain inquiry records only as long as needed for the purpose above and
              for legitimate business or legal requirements, after which they are securely disposed of.
            </p>
          </Section>

          <Section title="5. Your rights">
            <p>
              Under the Data Privacy Act of 2012 (RA 10173), you have the right to be informed, to access and
              correct your data, to object to processing, and to withdraw your consent at any time. Consent is
              voluntary and withdrawing it will not be held against you.
            </p>
          </Section>

          <Section title="6. Contact / Data requests">
            <p>
              To exercise your rights, withdraw consent, or raise a privacy concern, contact us at{' '}
              <a href="mailto:fms.medequip@gmail.com" className="text-[#00FFD1] hover:underline">
                fms.medequip@gmail.com
              </a>
              . We will respond in accordance with RA 10173 and the rules of the National Privacy Commission.
            </p>
          </Section>

          <div className="mt-12">
            <Link to="/contact-ph" className="btn-primary" data-testid="privacy-back-to-contact">
              Back to Inquiry Form
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
